import { render } from "./FormLinkSelect.vue?vue&type=template&id=cd4cf8d8&scoped=true"
import script from "./FormLinkSelect.vue?vue&type=script&lang=js"
export * from "./FormLinkSelect.vue?vue&type=script&lang=js"

import "./FormLinkSelect.vue?vue&type=style&index=0&id=cd4cf8d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd4cf8d8"

export default script